import {
  Save,
  X,
  Trash2,
  ChevronUp,
  ChevronDown,
  Sparkles,
  Eye,
  EyeOff
} from "lucide-react";
// ...
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db, auth, storage } from "./firebase";
import { getFunctions, httpsCallable } from "firebase/functions";
import {
  collection,
  getDocs,
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  addDoc,
  setDoc,
  onSnapshot
} from "firebase/firestore";
// === PROMO & VISIBILITÀ TOGGLE ===
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { useAuthState } from "react-firebase-hooks/auth";

import TranslateWithAIModal from "./TranslateWithAIModal";
import AICreditsModal from "./AICreditsModal";
import "./TranslateWithAIModal.css";
import Navbar from "./Navbar";
import AIImagePopup from "./AIImagePopup";
import EditDishModal from "./components/EditDishModal";
import "./MenuEditor.css";
import "./navbar-spacing.css";
import "./responsive-theme.css";
import "./responsive-utilities.css";

// Functions Europe-West1 singleton
const functionsEU = getFunctions(undefined, "europe-west1");
const functionsUS = getFunctions(undefined, "us-central1");

/**
 * Upload AI base64 image via Firebase Function (returns a public URL).
 * NOTE: Function name must exist in your Firebase Functions deployment.
 */
const uploadAiImageViaFunction = async (base64Image, localeTag) => {
  const uploadFn = httpsCallable(functionsUS, "uploadAiImage");
  const result = await uploadFn({ base64Image, localeTag });
  
  return result.data?.imageUrl || "";
};

// ====== ALLERGENI EU (1169/2011) ======

const ALLERGENI_EU = [
  "Cereali contenenti glutine",
  "Crostacei",
  "Uova",
  "Pesce",
  "Arachidi",
  "Soia",
  "Latte",
  "Frutta a guscio",
  "Sedano",
  "Senape",
  "Semi di sesamo",
  "Anidride solforosa e solfiti",
  "Lupini",
  "Molluschi",
];

// Normalizza allergeni in array di stringhe
const normalizeAllergeni = (value) => {
  if (Array.isArray(value)) return value;
  if (typeof value === "string") {
    return value.split(",").map(a => a.trim()).filter(Boolean);
  }
  return [];
};

export default function MenuEditor() {

  const [loadingAISuggestions, setLoadingAISuggestions] = useState(false);
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
const [popupLimitePiatti, setPopupLimitePiatti] = useState(false);

  // ====== Core state ======
  const [localeTag, setLocaleTag] = useState("");
  const [menu, setMenu] = useState([]);
  const [categorie, setCategorie] = useState([]);
  const [allergeniCustom, setAllergeniCustom] = useState([]);
  const [errore, setErrore] = useState("");
  const [loading, setLoading] = useState(true);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  // ====== InfoLocale state ======
  const [infoLocale, setInfoLocale] = useState({});
  useEffect(() => {
  if (!localeTag) return;

  const refLocale = doc(db, "locali", localeTag);

  const unsub = onSnapshot(refLocale, (snap) => {
    if (snap.exists()) {
      setInfoLocale(snap.data());
    } else {
      setInfoLocale({});
    }
  });

  return () => unsub();
}, [localeTag]);


  // ====== Coperto ======
  const [prezzoCoperto, setPrezzoCoperto] = useState("");
  const [loadingCoperto, setLoadingCoperto] = useState(false);
  const [loadingMenuConFoto, setLoadingMenuConFoto] = useState(false);

  // Derivato da infoLocale — sempre sincronizzato con Firestore via onSnapshot
  const menuConFoto = infoLocale.menuConFoto !== false;


  // ====== Filter ======
  const [filtro, setFiltro] = useState("");

  // ====== UI ======
  const [mostraPiatti, setMostraPiatti] = useState(false);
  // Crediti AI Modal
  const [showCreditsModal, setShowCreditsModal] = useState(false);

  // ====== Categories add/edit ======
  const [mostraGestioneCategorie, setMostraGestioneCategorie] = useState(false);
  const [nuovaCategoria, setNuovaCategoria] = useState("");
  const [mostraFormCategoria, setMostraFormCategoria] = useState(false);
  const [mostraModificaCat, setMostraModificaCat] = useState(false);
  const [catSelezionata, setCatSelezionata] = useState(null);
  const [nuovoNomeCat, setNuovoNomeCat] = useState("");

  // ====== Inline edit dish ======
  const [editingDishId, setEditingDishId] = useState(null);
  const [dishToEdit, setDishToEdit] = useState(null);
  const [form, setForm] = useState({
    nome: "",
    prezzo: "",
    categoria: "",
    descrizione: "",
    allergeni: [],
    ingredienti: ""
  });

  const [fileImmagine, setFileImmagine] = useState(null);
  const [anteprima, setAnteprima] = useState("");
  const [immagineUrlAIEdit, setImmagineUrlAIEdit] = useState("");
  const [aiImageUploading, setAiImageUploading] = useState(false);

  // ====== Loader states for save buttons ======
  const [isSavingEdit, setIsSavingEdit] = useState(false);
  const [isSavingAdd, setIsSavingAdd] = useState(false);

  // ====== AI Translation (GLOBAL e SINGLE) ======
  const [showTranslateAIModal, setShowTranslateAIModal] = useState(false);
  const [dishToTranslate, setDishToTranslate] = useState(null);
  const [singleTranslateDish, setSingleTranslateDish] = useState(null);

  // ====== Add dishes panel (hidden until user clicks ➕) ======
  const [showAddDish, setShowAddDish] = useState(false);

  // Keep the original multi-add capability, but inside the inline panel.
  const [piattiDaAggiungere, setPiattiDaAggiungere] = useState([
    {
      nome: "",
      prezzo: "",
      categoria: "",
      descrizione: "",
      allergeni: [],
      ingredienti: "",
      fileImmagine: null,
      anteprima: null,
      immagineUrlAI: null
    }
  ]);

  // ====== AI credits & popup ======
  const [aiCredits, setAiCredits] = useState(null);
  const [aiEnabled, setAiEnabled] = useState(true);

  // ====== AI Translation credits ======
  const [translationCredits, setTranslationCredits] = useState(0);
  const [translationEnabled, setTranslationEnabled] = useState(false);

  // ====== Add allergene ======
  const [showAddAllergeneFor, setShowAddAllergeneFor] = useState(null); // "add" | "edit" | null
  const [nuovoAllergene, setNuovoAllergene] = useState("");
  const [addAllergeneForIndex, setAddAllergeneForIndex] = useState(null); // indice piatto in piattiDaAggiungere
  const [forceSelectAllergene, setForceSelectAllergene] = useState(null); // allergene da selezionare forzatamente nel modal

  // === PROMO & VISIBILITÀ TOGGLE ===


  // ====== Combined allergeni list (EU + custom) ======
  const allergeniCompleti = useMemo(() => {
    const combined = [...ALLERGENI_EU];
    allergeniCustom.forEach(allergen => {
      if (!combined.includes(allergen)) {
        combined.push(allergen);
      }
    });
    return combined;
  }, [allergeniCustom]);

  const [showAIPopup, setShowAIPopup] = useState(false);
  const [aiPopupDishName, setAiPopupDishName] = useState("");
  const [aiPopupContext, setAiPopupContext] = useState({
    mode: null, // "add" | "edit"
    index: null // for add: index of piattiDaAggiungere
  });

  // ====== Firestore loaders ======
  const caricaMenuPerLocale = async (tagLocale) => {
    const snapshot = await getDocs(collection(db, "menu"));
    return snapshot.docs
      .map((d) => ({ id: d.id, ...d.data() }))
      .filter((p) => p.localeTag === tagLocale);
  };

  const caricaCategoriePerLocale = async (tagLocale) => {
    const snapshot = await getDocs(collection(db, "categorie"));
    return snapshot.docs
      .map((d) => ({ id: d.id, ...d.data() }))
      .filter((c) => c.localeTag === tagLocale)
      .sort((a, b) => (a.ordine || 0) - (b.ordine || 0));
  };

  // ====== Initial user localeTag ======
  useEffect(() => {
    const fetchUserData = async () => {
      if (!user) {
        setLoading(false);
        return;
      }
      try {
        const refUtente = doc(db, "utenti", user.uid);
        const snap = await getDoc(refUtente);
        if (snap.exists()) {
          const data = snap.data();
          if (data.localeTag) {
            setLocaleTag(data.localeTag);
            localStorage.setItem("localeTag", data.localeTag);
          } else {
            setErrore("⚠️ Nessun locale associato al tuo account.");
          }
        } else {
          setErrore("⚠️ Utente non trovato.");
        }
      } catch (e) {
        console.error("Errore caricamento utente:", e);
        setErrore("❌ Errore durante il caricamento utente.");
      }
    };
    fetchUserData();
  }, [user]);

  // ====== Load menu ======
  useEffect(() => {
    if (!localeTag) {
      setMenu([]);
      setLoading(false);
      return;
    }

    setLoading(true);

    const q = collection(db, "menu");

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const piatti = snapshot.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .filter((p) => p.localeTag === localeTag);

      setMenu(piatti);
      setLoading(false);
    }, (error) => {
      console.error("Errore realtime menu:", error);
      setErrore("❌ Errore realtime menu.");
      setLoading(false);
    });

    return () => unsubscribe();
  }, [localeTag]);

  // ====== Load AI Translation credits ======
  const fetchTranslationCredits = useCallback(async () => {
    if (!localeTag) return;
    try {
      const refTrans = doc(db, "restaurants", localeTag, "ai", "translations");
      const snap = await getDoc(refTrans);

      if (snap.exists()) {
        const data = snap.data();
        setTranslationCredits(
          typeof data.translationCredits === "number" ? data.translationCredits : 0
        );
        setTranslationEnabled(data.enabled === true);
      } else {
        setTranslationCredits(0);
        setTranslationEnabled(false);
      }
    } catch (e) {
      console.error("Errore caricamento crediti traduzioni AI:", e);
      setTranslationCredits(0);
      setTranslationEnabled(false);
    }
  }, [localeTag]);

  useEffect(() => {
    fetchTranslationCredits();
  }, [fetchTranslationCredits]);

  // ====== Load categories ======
  useEffect(() => {
    if (!localeTag) {
      setCategorie([]);
      return;
    }

    const q = collection(db, "categorie");

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const lista = snapshot.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .filter((c) => c.localeTag === localeTag)
        .sort((a, b) => (a.ordine || 0) - (b.ordine || 0));

      setCategorie(lista);
    }, (error) => {
      console.error("Errore realtime categorie:", error);
      setErrore("❌ Errore realtime categorie.");
    });

    return () => unsubscribe();
  }, [localeTag]);

  // ====== Load allergeni custom ======
  useEffect(() => {
    const fetchAllergeni = async () => {
      if (!localeTag) return;
      try {
        const snapshot = await getDocs(collection(db, "allergeni"));
        const allergeni = snapshot.docs
          .filter(doc => doc.data().localeTag === localeTag)
          .map(doc => doc.data().nome)
          .filter(Boolean);
        setAllergeniCustom(allergeni);
      } catch (e) {
        console.error("Errore durante il caricamento degli allergeni:", e);
      }
    };
    fetchAllergeni();
  }, [localeTag]);

  // ====== Save new allergene ======
  const handleSaveAllergene = async () => {
    // Verifica autenticazione
    if (!user) {
      alert("Devi essere autenticato per aggiungere allergeni");
      return null;
    }

    // Verifica localeTag
    if (!localeTag) {
      alert("Nessun locale associato al tuo account");
      return null;
    }

    const nome = nuovoAllergene.trim();
    if (!nome) {
      alert("Inserisci il nome dell'allergene");
      return null;
    }

    // Controlla duplicati (case-insensitive)
    const esistente = allergeniCompleti.find(
      (a) => a.toLowerCase() === nome.toLowerCase()
    );
    if (esistente) {
      alert("Allergene già presente");
      return null;
    }

    try {
      await addDoc(collection(db, "allergeni"), {
        nome,
        localeTag,
        createdAt: new Date(),
      });

      // Aggiorna lista locale
      setAllergeniCustom((prev) => [...prev, nome]);
      setNuovoAllergene("");
      setShowAddAllergeneFor(null);

      // Ritorna il nome dell'allergene salvato
      return nome;
    } catch (e) {
      console.error("Errore durante il salvataggio dell'allergene:", e);
      alert("Errore durante il salvataggio");
      return null;
    }
  };


  // ====== Load coperto ======
  useEffect(() => {
    const fetchCoperto = async () => {
      if (!localeTag) return;
      setLoadingCoperto(true);
      try {
        const docRef = doc(db, "locali", localeTag);
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          const localeData = snap.data();
          setPrezzoCoperto(
            typeof localeData.prezzoCoperto === "number"
              ? String(localeData.prezzoCoperto)
              : (localeData.prezzoCoperto || "")
          );
        } else {
          setPrezzoCoperto("");
        }
      } catch (e) {
        console.error("Errore durante il caricamento del coperto:", e);
        setPrezzoCoperto("");
      } finally {
        setLoadingCoperto(false);
      }
    };
    fetchCoperto();
  }, [localeTag]);

  // ====== Salva coperto ======


  // ====== Load AI credits ======

  useEffect(() => {
    if (!localeTag) return;

    const refCrediti = doc(db, "aiCredits", localeTag);

    const unsub = onSnapshot(refCrediti, (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setAiCredits(typeof data.credits === "number" ? data.credits : 0);
        setAiEnabled(data.enabled !== false);
      } else {
        setAiCredits(0);
        setAiEnabled(false);
      }
    });

    return () => unsub();
  }, [localeTag]);

  // ====== Navigation ======
  const tornaAllaDashboard = () => navigate("/dashboard-gestore");

  // ====== Refresh helpers ======
  const aggiornaMenu = async () => {
    if (!localeTag) return;
    try {
      const piatti = await caricaMenuPerLocale(localeTag);
      setMenu(piatti);
    } catch (e) {
      console.error("Errore durante l'aggiornamento del menu:", e);
      setErrore("❌ Errore durante l'aggiornamento del menu.");
    }
  };

  const aggiornaCategorie = async () => {
    if (!localeTag) return;
    try {
      const lista = await caricaCategoriePerLocale(localeTag);
      setCategorie(lista);
    } catch (e) {
      console.error("Errore durante l'aggiornamento delle categorie:", e);
      setErrore("❌ Errore durante l'aggiornamento delle categorie.");
    }
  };

  // ====== Upload (manual file for EDIT dish) ======
  const uploadImmagine = async () => {
    if (!fileImmagine) return null;
    try {
      const nomeFile = `${localeTag}/${Date.now()}_${fileImmagine.name}`;
      const storageRef = ref(storage, nomeFile);
      await uploadBytes(storageRef, fileImmagine);
      return await getDownloadURL(storageRef);
    } catch (err) {
      console.error("[MenuEditor] uploadImmagine error", err);
      setErrore("❌ Errore durante l'upload dell'immagine.");
      return null;
    }
  };

  // ====== INLINE EDIT helpers ======
  const closeInlineEdit = () => {
    setEditingDishId(null);
    setForm({ nome: "", prezzo: "", categoria: "", descrizione: "", allergeni: [], ingredienti: "" });
    setFileImmagine(null);
    setAnteprima("");
    setImmagineUrlAIEdit("");
  };

  const openInlineEdit = (piatto) => {
    setEditingDishId(piatto.id);
    // Nome e descrizione DEVONO essere stringhe
    const nomeStr = piatto.nome || "";
    const descStr = piatto.descrizione || "";
    
    setForm({
      nome: nomeStr,
      prezzo: piatto.prezzo || "",
      categoria: piatto.categoria || "",
      descrizione: descStr,
      allergeni: normalizeAllergeni(piatto.allergeni),
      ingredienti: Array.isArray(piatto.ingredienti)
        ? piatto.ingredienti.join(", ")
        : (piatto.ingredienti || ""),
    });
    setFileImmagine(null);
    setAnteprima("");
    setImmagineUrlAIEdit("");
  };

  const salvaModifiche = async () => {
    if (aiImageUploading) {
      alert("Attendi il completamento del caricamento dell'immagine AI.");
      return;
    }
    if (!editingDishId) return;

    setIsSavingEdit(true);
    try {
      const piattoEditing = menu.find((p) => p.id === editingDishId);
      let immagineUrl = piattoEditing?.immagineUrl || "";

      if (immagineUrlAIEdit) {
        immagineUrl = immagineUrlAIEdit;
      } else if (fileImmagine) {
        const nuovaUrl = await uploadImmagine();
        if (nuovaUrl) immagineUrl = nuovaUrl;
      }

      // safety: don't write base64
      if (immagineUrl && immagineUrl.startsWith("data:image")) {
        alert("Immagine non ancora pronta. Riprova tra un istante.");
        return;
      }

      // Salvataggio piatto con nome/descrizione stringhe
      // Preserva le traduzioni esistenti e aggiorna translations.it

        await updateDoc(doc(db, "menu", editingDishId), {
          nome: form.nome,
          descrizione: form.descrizione || "",
          prezzo: parseFloat(String(form.prezzo).replace(",", ".")) || 0,
        categoria: form.categoria,
        allergeni: Array.isArray(form.allergeni) ? form.allergeni : [],
        ingredienti: typeof form.ingredienti === "string"
          ? form.ingredienti.split(",").map(i => i.trim()).filter(Boolean)
          : [],
        immagineUrl,
        updatedAt: new Date(),

        translations: {
          ...(piattoEditing.translations || {}),
          it: {
            name: form.nome,
            description: form.descrizione || "",
            source: "manual",
            updatedAt: new Date()
          }
        }
      });

      closeInlineEdit();
      await aggiornaMenu();
    } catch (error) {
      console.error("Errore durante il salvataggio del piatto:", error);
      setErrore("❌ Errore durante il salvataggio.");
    } finally {
      setIsSavingEdit(false);
    }
  };

  // ====== Dish actions ======
  const eliminaPiatto = (id) => {
    const piatto = menu.find((p) => p.id === id);

    setDeleteConfirm({
      id,
      nome: piatto?.nome || "questo piatto"
    });
  };

  const confermaEliminazione = async () => {
    if (!deleteConfirm) return;

    try {
      await deleteDoc(doc(db, "menu", deleteConfirm.id));
      await aggiornaMenu();
    } catch (error) {
      console.error("Errore eliminazione:", error);
      setErrore("❌ Errore durante l'eliminazione.");
    } finally {
      setDeleteConfirm(null);
    }
  };

const toggleVisibilePiatto = async (id) => {
  try {
    const piatto = menu.find((p) => p.id === id);

    if (!piatto) return;

    const nuovoVisibile =
      piatto.visibile === false;

    await updateDoc(
      doc(db, "menu", id),
      {
        visibile: nuovoVisibile
      }
    );

    // La lista si aggiorna già tramite onSnapshot.
  } catch (error) {
    console.error(
      "Errore durante il cambio visibilità del piatto:",
      error
    );

    setErrore(
      "❌ Errore durante il cambio visibilità del piatto."
    );
  }
};

  const togglePromozionePiatto = async (id) => {
    try {
      const piatto = menu.find((p) => p.id === id);
      const nuovaPromozione = piatto?.inPromozione === true ? false : true;
      await updateDoc(doc(db, "menu", id), { inPromozione: nuovaPromozione });
      await aggiornaMenu();
    } catch (error) {
      console.error("Errore durante il cambio promozione del piatto:", error);
      setErrore("❌ Errore durante il cambio promozione del piatto.");
    }
  };

  const spostaPiattoSu = async (piatto) => {
    const piattiCategoria = menu
      .filter((p) => p.categoria === piatto.categoria)
      .sort((a, b) => (a.ordine || 0) - (b.ordine || 0));

    const index = piattiCategoria.findIndex((p) => p.id === piatto.id);
    if (index <= 0) return;

    try {
      const nuovaLista = [...piattiCategoria];
      [nuovaLista[index], nuovaLista[index - 1]] = [
        nuovaLista[index - 1],
        nuovaLista[index]
      ];
      for (let i = 0; i < nuovaLista.length; i++) {
        await updateDoc(doc(db, "menu", nuovaLista[i].id), { ordine: i + 1 });
      }
      await aggiornaMenu();
    } catch (error) {
      console.error("Errore spostaPiattoSu:", error);
      setErrore(`❌ Errore durante lo spostamento: ${error.message}`);
    }
  };

  const spostaPiattoGiu = async (piatto) => {
    const piattiCategoria = menu
      .filter((p) => p.categoria === piatto.categoria)
      .sort((a, b) => (a.ordine || 0) - (b.ordine || 0));

    const index = piattiCategoria.findIndex((p) => p.id === piatto.id);
    if (index >= piattiCategoria.length - 1) return;

    try {
      const nuovaLista = [...piattiCategoria];
      [nuovaLista[index], nuovaLista[index + 1]] = [
        nuovaLista[index + 1],
        nuovaLista[index]
      ];
      for (let i = 0; i < nuovaLista.length; i++) {
        await updateDoc(doc(db, "menu", nuovaLista[i].id), { ordine: i + 1 });
      }
      await aggiornaMenu();
    } catch (error) {
      console.error("Errore spostaPiattoGiu:", error);
      setErrore(`❌ Errore durante lo spostamento: ${error.message}`);
    }
  };

  // ====== Categories CRUD + order ======
  const aggiungiCategoria = async () => {
    if (!nuovaCategoria.trim() || !localeTag) return;
    try {
      const snapshot = await getDocs(collection(db, "categorie"));
      const tutteCategorie = snapshot.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .filter((cat) => cat.localeTag === localeTag);

      const esiste = tutteCategorie.some(
        (c) => c.nome.trim().toLowerCase() === nuovaCategoria.trim().toLowerCase()
      );
      if (esiste) {
        setErrore("❌ Categoria già esistente.");
        return;
      }

      const maxOrdine =
        tutteCategorie.length > 0
          ? Math.max(...tutteCategorie.map((c) => c.ordine || 0))
          : 0;

      await addDoc(collection(db, "categorie"), {
        nome: nuovaCategoria.trim(),
        localeTag,
        ordine: maxOrdine + 1,
        visibile: true,
        icon: "default"
      });

      setNuovaCategoria("");
      
    } catch (error) {
      console.error("Errore durante l'aggiunta della categoria:", error);
      setErrore("❌ Errore durante l'aggiunta della categoria.");
    }
  };

  const eliminaCategoria = async (id) => {
    const categoria = categorie.find((c) => c.id === id);
    const nomeCategoria = categoria ? categoria.nome : "questa categoria";
    if (
      !window.confirm(
        `⚠️ ATTENZIONE\n\nVuoi davvero eliminare la categoria "${nomeCategoria}"?\n\nQuesta operazione non può essere annullata.`
      )
    )
      return;

    try {
      await deleteDoc(doc(db, "categorie", id));
      
    } catch (error) {
      console.error("Errore durante l'eliminazione della categoria:", error);
      setErrore("❌ Errore durante l'eliminazione della categoria.");
    }
  };

  const salvaCoperto = async () => {
    try {
      // Keep both: legacy "coperti" + field on "locali" (as in your project)
      await setDoc(doc(db, "coperti", localeTag), { prezzo: prezzoCoperto });
      const localeRef = doc(db, "locali", localeTag);
      await updateDoc(localeRef, { prezzoCoperto: parseFloat(String(prezzoCoperto).replace(",", ".")) || 0 });

      setErrore("success_coperto");
      setTimeout(() => {
        setErrore("");
      }, 2000);
      // niente alert → UX pulita
    } catch (error) {
      console.error("Errore durante il salvataggio del coperto:", error);
      setErrore("❌ Errore durante il salvataggio del coperto.");
    }
  };

  // ====== AI: Genera Suggerimenti ======
  const generaSuggerimentiAI = async () => {
    if (loadingAISuggestions) return;

    if (!localeTag) {
      alert("Locale non valido");
      return;
    }

    if (!menu.length) {
      alert("Menu vuoto");
      return;
    }

    setLoadingAISuggestions(true);

    try {




      const genera = httpsCallable(functionsEU, "generateMenuSuggestions");

      const payload = menu.map(p => ({
        id: p.id,
        nome: p.nome,
        categoria: p.categoria,
        descrizione: p.descrizione || ""
      }));

      const res = await genera({ dishes: payload });

      const suggestions = res.data?.suggestions || {};


      if (Object.keys(suggestions).length > 0) {
        await updateDoc(doc(db, "locali", localeTag), {
          aiSuggestions: suggestions
        });
      }

      // Feedback gestito esternamente
    } catch (err) {
      console.error(err);
      alert("❌ Errore generazione suggerimenti");
    } finally {
      setLoadingAISuggestions(false);
    }
  };

  const apriModificaCat = (cat) => {
    setCatSelezionata(cat);
    setNuovoNomeCat(cat.nome);
    setMostraModificaCat(true);
  };

  const salvaModificaCat = async () => {
    if (!catSelezionata) return;
    try {
      await updateDoc(doc(db, "categorie", catSelezionata.id), { nome: nuovoNomeCat });
      setMostraModificaCat(false);
      setCatSelezionata(null);
      setNuovoNomeCat("");
      
    } catch (error) {
      console.error("Errore durante la modifica della categoria:", error);
      setErrore("❌ Errore durante la modifica della categoria.");
    }
  };

  const toggleVisibilitaCat = async (id) => {
    try {
      const categoria = categorie.find((c) => c.id === id);
      const nuovoVisibile = categoria?.visibile === false ? true : false;
      await updateDoc(doc(db, "categorie", id), { visibile: nuovoVisibile });
      
    } catch (error) {
      console.error("Errore durante il cambio visibilità della categoria:", error);
      setErrore("❌ Errore durante il cambio visibilità della categoria.");
    }
  };


  const spostaSu = async (cat) => {
    const index = categorie.findIndex((c) => c.id === cat.id);
    if (index <= 0) return;

    try {
      const nuovaLista = [...categorie];
      [nuovaLista[index], nuovaLista[index - 1]] = [nuovaLista[index - 1], nuovaLista[index]];
      for (let i = 0; i < nuovaLista.length; i++) {
        await updateDoc(doc(db, "categorie", nuovaLista[i].id), { ordine: i + 1 });
      }
      setCategorie(nuovaLista);
      
    } catch (error) {
      console.error("Errore spostaSu:", error);
      setErrore(`❌ Errore durante lo spostamento: ${error.message}`);
    }
  };

  const spostaGiu = async (cat) => {
    const index = categorie.findIndex((c) => c.id === cat.id);
    if (index >= categorie.length - 1) return;

    try {
      const nuovaLista = [...categorie];
      [nuovaLista[index], nuovaLista[index + 1]] = [nuovaLista[index + 1], nuovaLista[index]];
      for (let i = 0; i < nuovaLista.length; i++) {
        await updateDoc(doc(db, "categorie", nuovaLista[i].id), { ordine: i + 1 });
      }
      setCategorie(nuovaLista);
      
    } catch (error) {
      console.error("Errore spostaGiu:", error);
      setErrore(`❌ Errore durante lo spostamento: ${error.message}`);
    }
  };

  // ====== Multi-add helpers (inside the add panel) ======
  const handleFilePiattoNuovo = (idx, file) => {
    setPiattiDaAggiungere((prev) => {
      const nuovi = [...prev];
      if (!nuovi[idx]) return prev;

      nuovi[idx] = {
        ...nuovi[idx],
        fileImmagine: file || null,
        immagineUrlAI: null
      };

      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPiattiDaAggiungere((prev2) => {
            const copy = [...prev2];
            if (!copy[idx]) return prev2;
            copy[idx] = { ...copy[idx], anteprima: reader.result };
            return copy;
          });
        };
        reader.readAsDataURL(file);
      } else {
        nuovi[idx].anteprima = null;
      }

      return nuovi;
    });
  };

  const resetAddPanel = () => {
    setPiattiDaAggiungere([
      {
        nome: "",
        prezzo: "",
        categoria: "",
        descrizione: "",
        allergeni: [],
        ingredienti: "",
        fileImmagine: null,
        anteprima: null,
        immagineUrlAI: null
      }
    ]);
  };

  const apriAIPerNuovoPiatto = (idx) => {
    if (!aiEnabled) return window.alert("La generazione con AI è disabilitata per questo locale.");
    if (!aiCredits || aiCredits <= 0) return window.alert("Crediti AI esauriti. Contatta l'amministratore.");

    const piatto = piattiDaAggiungere[idx];
    const parts = [];
    if (piatto?.nome?.trim()) parts.push(piatto.nome.trim());
    if (piatto?.categoria?.trim()) parts.push(`Categoria: ${piatto.categoria.trim()}`);
    if (piatto?.descrizione?.trim()) parts.push(piatto.descrizione.trim());
    const descrizioneCompleta = parts.length ? parts.join(" — ") : "Nuovo piatto";

    setAiPopupContext({ mode: "add", index: idx });
    setAiPopupDishName(descrizioneCompleta);
    setShowAIPopup(true);
  };

  const apriAIPerModifica = () => {
    if (!editingDishId) return;

    const piattoEditing = menu.find((p) => p.id === editingDishId);
    if (!piattoEditing) return;

    if (!aiEnabled) return window.alert("La generazione con AI è disabilitata per questo locale.");
    if (!aiCredits || aiCredits <= 0) return window.alert("Crediti AI esauriti. Contatta l'amministratore.");

    const parts = [];
    if (form.nome?.trim()) parts.push(form.nome.trim());
    else if (piattoEditing.nome?.trim()) parts.push(piattoEditing.nome.trim());
    if (form.categoria?.trim()) parts.push(`Categoria: ${form.categoria.trim()}`);
    if (form.descrizione?.trim()) parts.push(form.descrizione.trim());
    else if (piattoEditing.descrizione?.trim()) parts.push(piattoEditing.descrizione.trim());

    const descrizioneCompleta = parts.length ? parts.join(" — ") : "Piatto";
    setAiPopupContext({ mode: "edit", index: null });
    setAiPopupDishName(descrizioneCompleta);
    setShowAIPopup(true);
  };

  // Funzione di compressione base64
  const compressBase64Image = (base64, maxWidth = 800, quality = 0.75) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = base64;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        let width = img.width;
        let height = img.height;

        // Ridimensiona mantenendo proporzioni
        if (width > maxWidth) {
          height = (maxWidth / width) * height;
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;

        ctx.drawImage(img, 0, 0, width, height);

        const compressedBase64 = canvas.toDataURL("image/jpeg", quality);
        resolve(compressedBase64);
      };

      img.onerror = (err) => reject(err);
    });
  };

  // Called by AIImagePopup
  const handleAIComplete = async ({ imageBase64 }) => {
    const imageUrl = `data:image/png;base64,${imageBase64}`;
    try {
      if (!imageUrl) {
        setShowAIPopup(false);
        return;
      }

      // STEP 1: instant preview base64
      if (aiPopupContext.mode === "edit") {
        setAnteprima(imageUrl);
        setImmagineUrlAIEdit(imageUrl);
        setFileImmagine(null);
      }

      if (aiPopupContext.mode === "add") {
        setPiattiDaAggiungere((prev) => {
          const copy = [...prev];
          const idx = aiPopupContext.index;
          if (idx === null || copy[idx] == null) return prev;
          copy[idx] = { ...copy[idx], anteprima: imageUrl, immagineUrlAI: imageUrl, fileImmagine: null };
          return copy;
        });
      }

      // STEP 2: upload if base64 -> URL
      let finalUrl = imageUrl;
      if (imageUrl.startsWith("data:image")) {
        setAiImageUploading(true);

        // 🔥 Compressione prima dell’upload
        const compressed = await compressBase64Image(imageUrl, 800, 0.75);

        finalUrl = await uploadAiImageViaFunction(
          compressed,
          localeTag || localStorage.getItem("localeTag")
        );

        setAiImageUploading(false);
      }

      // STEP 3: replace base64 with URL
      if (aiPopupContext.mode === "edit") {
        setAnteprima(finalUrl);
        setImmagineUrlAIEdit(finalUrl);
      }

      if (aiPopupContext.mode === "add") {
        setPiattiDaAggiungere((prev) => {
          const copy = [...prev];
          const idx = aiPopupContext.index;
          if (idx === null || copy[idx] == null) return prev;
          copy[idx] = { ...copy[idx], anteprima: finalUrl, immagineUrlAI: finalUrl };
          return copy;
        });
      }
    } catch (err) {
      console.error("Errore handleAIComplete:", err);
      alert("Errore durante il salvataggio dell'immagine AI.");
      setAiImageUploading(false);
    } finally {
      setShowAIPopup(false);
      setAiPopupContext({ mode: null, index: null });
      setAiPopupDishName("");
    }
  };

  const salvaPiattiNuovi = async () => {
    if (!localeTag) return;

    const limite = infoLocale.limitePiatti;

if (
  limite !== null &&
  limite !== undefined &&
  (menu.length + piattiDaAggiungere.filter(
    p => p.nome && p.prezzo && p.categoria
  ).length) > limite
) {
setPopupLimitePiatti(true);
return;
}

    if (aiImageUploading) {
      alert("Attendi il completamento del caricamento dell'immagine AI.");
      return;
    }

    const validi = piattiDaAggiungere.filter((p) => p.nome && p.prezzo && p.categoria);
    if (validi.length === 0) {
      alert("Compila almeno Nome, Prezzo e Categoria per almeno un piatto.");
      return;
    }

    setIsSavingAdd(true);
    try {
      for (const p of validi) {
        let immagineUrl = "";

        // File upload
        if (p.fileImmagine) {
          const nomeFile = `${localeTag}/${Date.now()}_${p.fileImmagine.name}`;
          const storageRef = ref(storage, nomeFile);
          await uploadBytes(storageRef, p.fileImmagine);
          immagineUrl = await getDownloadURL(storageRef);
        }
        // AI image URL
        else if (p.immagineUrlAI) {
          immagineUrl = p.immagineUrlAI;
        }

        // 🔐 VALIDAZIONE STRINGHE
        if (typeof p.nome !== "string" || typeof p.descrizione !== "string") {
          console.error("❌ Tentativo di salvare nome/descrizione non stringa", p);
          throw new Error("Nome o descrizione non validi");
        }

        // Salvataggio piatto nuovo o modifica esistente
        if (p.id) {
          await updateDoc(doc(db, "menu", p.id), {
            nome: p.nome,
            descrizione: p.descrizione || "",
            prezzo: parseFloat(String(p.prezzo).replace(",", ".")) || 0,
            categoria: p.categoria,
            allergeni: normalizeAllergeni(p.allergeni),
            ingredienti: p.ingredienti
              ? p.ingredienti.split(",").map(i => i.trim()).filter(Boolean)
              : [],
            immagineUrl,
            updatedAt: new Date()
          });
        } else {
          await addDoc(collection(db, "menu"), {
            nome: p.nome,
            descrizione: p.descrizione || "",
            prezzo: parseFloat(String(p.prezzo).replace(",", ".")) || 0,
            categoria: p.categoria,
            allergeni: normalizeAllergeni(p.allergeni),
            ingredienti: p.ingredienti
              ? p.ingredienti.split(",").map(i => i.trim()).filter(Boolean)
              : [],
            localeTag,
            immagineUrl,
            visibile: true,
            inPromozione: false,
            createdAt: new Date(),
            updatedAt: new Date()
          });
        }
      }

      resetAddPanel();
      setShowAddDish(false);
      await aggiornaMenu();
    } catch (err) {
      console.error("Errore salvaPiattiNuovi:", err);
      setErrore("❌ Errore durante il caricamento dei nuovi piatti.");
    } finally {
      setIsSavingAdd(false);
    }
  };

  // ====== Computed list ======
  const piattiVisibili = useMemo(() => {
    return menu
      .filter((piatto) => !filtro || piatto.categoria === filtro)
      .sort((a, b) => (a.ordine || 0) - (b.ordine || 0));
  }, [menu, filtro]);

  // ====== Render ======
  return (
    <>
      <Navbar />

      <div className="menu-editor-page dark">
        {/* Header */}
        <div className="me-hero">
          <div>
            <h1>🍽️ Menu</h1>

<p>
  {menu.length} piatti • {categorie.length} categorie
  {infoLocale.suggerimentiAI !== false ? " • AI attiva" : ""}
</p>
          </div>
        </div>

        {/* Category chips */}
        


        {errore && (
          <div className="me-toast-wrapper">
            <div
              className={`me-toast ${
                errore === "success_coperto" ||
                errore === "success_ai_suggestions"
                  ? "success"
                  : errore === "ai_disabled_translation"
                  ? "warning"
                  : "error"
              }`}
            >
              <div className="me-toast-icon">
                {errore === "success_coperto" ||
                errore === "success_ai_suggestions"
                  ? "✓"
                  : errore === "ai_disabled_translation"
                  ? "⚠️"
                  : "!"}
              </div>

              <div className="me-toast-content">
                {errore === "success_coperto"
                  ? "Coperto aggiornato"
                  : errore === "success_ai_suggestions"
                  ? "Suggerimenti AI generati"
                  : errore === "ai_disabled_translation"
                  ? "Traduzioni AI disabilitate dall'amministratore"
                  : errore}
              </div>
            </div>
          </div>
        )}
        {!localeTag && !loading && (
          <p className="me-warning">⏳ Collega un locale al tuo account per gestire il menu.</p>
        )}


        {/* Dishes */}
        <section className="me-section">


          <div className="me-dish-bar">

  <div className="me-dish-bar-left">
  <div className="me-dish-bar-title-group">
    <h3>🍽 Piatti</h3>
    <span className="me-dish-count">{menu.length}</span>

    <span className="me-dish-bar-separator">•</span>

    <h3>📁 Categorie</h3>
    <span className="me-dish-count">{categorie.length}</span>
  </div>
</div>

<div className="me-dish-bar-actions">

 {/* GESTIONE MENU */}
<div className="me-actions-section">
  <div className="me-actions-section-title">🍽 Gestione menu</div>

  <div className="me-actions-group">
    <button
      className={`me-chip-btn ${mostraGestioneCategorie ? "active" : ""}`}
      onClick={() => setMostraGestioneCategorie(v => !v)}
    >
      📁 {mostraGestioneCategorie ? "Nascondi categorie" : "Gestisci categorie"}
    </button>

    <button
      className={`me-chip-btn ${mostraPiatti ? "active" : ""}`}
      onClick={() => setMostraPiatti(v => !v)}
    >
      🍽 {mostraPiatti ? "Nascondi piatti" : "Mostra piatti"}
    </button>

<button
  className="me-chip-btn primary"
  onClick={() => {

    const limite = infoLocale.limitePiatti;

    if (
      limite !== null &&
      limite !== undefined &&
      menu.length >= limite
    ) {
setPopupLimitePiatti(true);
return;
    }

    setEditingDishId(null);
    setShowAddDish(prev => !prev);
  }}
>
  + Aggiungi piatto
</button>
  </div>
</div>


{/* FUNZIONI AI */}
<div className="me-actions-section me-actions-section-ai">
  <div className="me-actions-section-title">✨ Intelligenza artificiale</div>

  <div className="me-actions-group">

    <button
      className="me-chip-btn"
      onClick={() => setShowCreditsModal(true)}
    >
      💳 Crediti
    </button>

    <button
      className="me-chip-btn ai"
      onClick={() => {
        if (infoLocale.translationEnabled !== true) {
          setErrore("ai_disabled_translation");
          setTimeout(() => setErrore(""), 2500);
          return;
        }

        setShowTranslateAIModal(true);
      }}
    >
      🤖 Traduci con AI
    </button>

    {infoLocale.adminMenuConFoto !== false && (
      <div className="me-foto-toggle-inline">
        <span className="me-foto-toggle-label">📷 Foto</span>
        <button
          className={`me-ios-toggle${menuConFoto ? " on" : ""}`}
          disabled={loadingMenuConFoto}
          onClick={async () => {
            const nuovoValore = !menuConFoto;
            setLoadingMenuConFoto(true);

            try {
              await updateDoc(doc(db, "locali", localeTag), {
                menuConFoto: nuovoValore
              });
            } catch (e) {
              console.error("Errore salvataggio menuConFoto:", e);
            } finally {
              setLoadingMenuConFoto(false);
            }
          }}
          aria-label={
            menuConFoto
              ? "Disabilita foto nel menu"
              : "Abilita foto nel menu"
          }
        >
          <span className="me-ios-toggle-thumb" />
        </button>
      </div>
    )}

    {infoLocale.adminSuggerimentiAI !== false && (
      <div
        className="me-chip-btn soft"
        style={{ gap: 10, paddingRight: 10 }}
      >
        <span>✨ Suggerimenti</span>

        <label className="switch" style={{ marginLeft: 6 }}>
          <input
            type="checkbox"
            checked={infoLocale.suggerimentiAI !== false}
            disabled={loadingAISuggestions}
            onChange={async (e) => {
              const value = e.target.checked;

              try {
                await setDoc(
                  doc(db, "locali", localeTag),
                  { suggerimentiAI: value },
                  { merge: true }
                );

                if (value === true) {
                  setErrore("");

                  setTimeout(() => {
                    setErrore("success_ai_suggestions");

                    setTimeout(() => {
                      setErrore("");
                    }, 2200);
                  }, 50);

                  generaSuggerimentiAI();
                }
              } catch (err) {
                console.error(
                  "Errore toggle suggerimenti AI:",
                  err
                );
              }
            }}
          />
          <span className="slider"></span>
        </label>
      </div>
    )}

  </div>
</div>

</div>

            {/* 🔥 FILTRI DENTRO LA STESSA CARD */}
            {mostraPiatti && (
              <div className="me-dish-filters-wrap">
                <div className="me-chips-row">
                  <button
                    className={`me-chip ${!filtro ? "me-chip-active" : ""}`}
                    onClick={() => setFiltro("")}
                  >
                    Tutto
                  </button>

                  {categorie.map((cat) => (
                    <button
                      key={cat.id}
                      className={`me-chip ${filtro === cat.nome ? "me-chip-active" : ""}`}
                      onClick={() => setFiltro(cat.nome)}
                    >
                      {cat.nome}
                    </button>
                  ))}
                </div>
              </div>
            )}

          </div>

          {/* Modal Crediti AI */}
          <AICreditsModal
            open={showCreditsModal}
            onClose={() => setShowCreditsModal(false)}
            imageCredits={aiCredits}
            translationCredits={translationCredits}
          />

          {/* Add panel (hidden until ➕) */}
          {showAddDish && (
            <div className="inline-edit-panel">
              <div className="me-card me-edit-card">
                <div className="me-edit-header">
                  <h3 className="me-section-title">➕ Aggiungi piatti</h3>
                  <button
                    className="me-action-pill icon"
                    onClick={() => {
                      resetAddPanel();
                      setShowAddDish(false);
                    }}
                    title="Chiudi"
                  >
                    <X size={16} />
                  </button>
                </div>

                {piattiDaAggiungere.map((p, idx) => (
                  <div key={idx} className="me-card me-add-dish-card" style={{ marginTop: 12 }}>
                    <div className="me-add-dish-header">
                      <span className="me-add-dish-index">Piatto {idx + 1}</span>
                      {piattiDaAggiungere.length > 1 && idx !== piattiDaAggiungere.length - 1 && (
                        <button
                          className="me-action-pill danger"
                          onClick={() => setPiattiDaAggiungere((prev) => prev.filter((_, i) => i !== idx))}
                        >
                          <Trash2 size={16} />
                          Rimuovi
                        </button>
                      )}
                    </div>

                    <div className="me-grid me-grid-2">
                      <div className="me-field">
                        <label className="me-label">Nome</label>
                        <input
                          type="text"
                          className="me-input"
                          value={p.nome}
                          onChange={(e) => {
                            const value = e.target.value;
                            setPiattiDaAggiungere((prev) => {
                              const copy = [...prev];
                              copy[idx] = { ...copy[idx], nome: value };
                              return copy;
                            });
                          }}
                        />
                      </div>

                      <div className="me-field">
                        <label className="me-label">Prezzo</label>
                        <input
                          type="text"
                          className="me-input"
                          value={p.prezzo}
                          onChange={(e) => {
                            const value = e.target.value;
                            setPiattiDaAggiungere((prev) => {
                              const copy = [...prev];
                              copy[idx] = { ...copy[idx], prezzo: value };
                              return copy;
                            });
                          }}
                        />
                      </div>
                    </div>

                    <div className="me-grid me-grid-2">
                      <div className="me-field">
                        <label className="me-label">Categoria</label>
                        <select
                          className="me-input"
                          value={p.categoria}
                          onChange={(e) => {
                            const value = e.target.value;
                            setPiattiDaAggiungere((prev) => {
                              const copy = [...prev];
                              copy[idx] = { ...copy[idx], categoria: value };
                              return copy;
                            });
                          }}
                        >
                          <option value="">Seleziona categoria</option>
                          {categorie.map((cat) => (
                            <option key={cat.id} value={cat.nome}>
                              {cat.nome}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="me-field">
                        <label className="me-label">Allergeni</label>

                        <div className="edit-dish-allergeni-pills">
                          {allergeniCompleti.map((allergen) => {
                            const attivo = Array.isArray(p.allergeni) && p.allergeni.includes(allergen);

                            return (
                              <button
                                key={allergen}
                                type="button"
                                className={`edit-dish-allergene-pill ${attivo ? "active" : ""}`}
                                onClick={() => {
                                  setPiattiDaAggiungere((prev) => {
                                    const copy = [...prev];
                                    const presenti = Array.isArray(copy[idx].allergeni) && copy[idx].allergeni.includes(allergen);
                                    copy[idx] = {
                                      ...copy[idx],
                                      allergeni: presenti
                                        ? copy[idx].allergeni.filter(a => a !== allergen)
                                        : [...copy[idx].allergeni, allergen],
                                    };
                                    return copy;
                                  });
                                }}
                              >
                                {allergen}
                              </button>
                            );
                          })}
                          <button
                            key="add-new"
                            type="button"
                            className="edit-dish-allergene-pill"
                            onClick={() => {
                              setShowAddAllergeneFor("add");
                              setAddAllergeneForIndex(idx);
                            }}
                          >
                            + Aggiungi
                          </button>
                        </div>

                        {Array.isArray(p.allergeni) && p.allergeni.length > 0 && (
                          <div className="edit-dish-allergeni-summary">
                            Selezionati: {p.allergeni.join(", ")}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="me-field">
                      <label className="me-label">Descrizione</label>
                      <textarea
                        className="me-input me-textarea"
                        value={p.descrizione}
                        onChange={(e) => {
                          const value = e.target.value;
                          setPiattiDaAggiungere((prev) => {
                            const copy = [...prev];
                            copy[idx] = { ...copy[idx], descrizione: value };
                            return copy;
                          });
                        }}
                      />
                    </div>

                    <div className="me-field">
                      <label className="me-label">Ingredienti</label>
                      <input
                        type="text"
                        className="me-input"
                        placeholder="es. pomodoro, mozzarella, carciofi"
                        value={p.ingredienti}
                        onChange={(e) => {
                          const value = e.target.value;
                          setPiattiDaAggiungere((prev) => {
                            const copy = [...prev];
                            copy[idx] = { ...copy[idx], ingredienti: value };
                            return copy;
                          });
                        }}
                      />
                    </div>

                    {/* Traduzione disponibile solo dopo il salvataggio */}

                    <div className="me-grid me-grid-2 me-align-center">
                      <div className="me-field">
                        <label className="me-label">Immagine</label>

                        <div className="me-ai-image-row">
                          <input
                            type="file"
                            accept="image/*"
                            className="me-input"
                            onChange={(e) => handleFilePiattoNuovo(idx, e.target.files?.[0] || null)}
                          />

                          <button
                            type="button"
                            className="me-action-pill promo active"
                            disabled={!aiEnabled || !aiCredits || aiImageUploading}
                            onClick={() => apriAIPerNuovoPiatto(idx)}
                          >
                            <Sparkles size={16} />
                            Genera con AI
                          </button>
                        </div>

                        {aiEnabled && aiCredits !== null && (
                          <p className="me-ai-credits-hint">
                            Crediti AI Immagini: <strong>{aiCredits}</strong><br />
                            Crediti AI Traduzioni: <strong>{translationCredits}</strong>
                          </p>
                        )}

                        {!aiEnabled && (
                          <p className="me-ai-credits-hint me-ai-credits-disabled">
                            La generazione con AI è disabilitata.
                          </p>
                        )}
                      </div>

                      <div className="me-field me-field-preview">
                        {p.anteprima || p.immagineUrlAI ? (
                          <img
                            src={p.anteprima || p.immagineUrlAI}
                            alt="Anteprima"
                            className="me-add-image-preview"
                          />
                        ) : (
                          <div className="me-add-image-placeholder">Nessuna immagine</div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}

                  <div className="me-edit-actions-footer me-edit-actions-3">

                    <button
                      className="me-action-pill soft big"
                      onClick={() => {
                        setPiattiDaAggiungere((prev) => [
                          ...prev,
                          {
                            nome: "",
                            prezzo: "",
                            categoria: "",
                            descrizione: "",
                            allergeni: [],
                            ingredienti: "",
                            fileImmagine: null,
                            anteprima: null,
                            immagineUrlAI: null
                          }
                        ]);
                      }}
                    >
                      + Aggiungi piatto
                    </button>

                    <button
                      className="me-action-pill primary big"
                      onClick={salvaPiattiNuovi}
                      disabled={isSavingAdd || aiImageUploading}
                    >
                      <Save size={16} />
                      {isSavingAdd ? "Salvataggio..." : "Salva piatti"}
                    </button>

                    <button
                      className="me-action-pill big"
                      onClick={() => {
                        resetAddPanel();
                        setShowAddDish(false);
                      }}
                    >
                      <X size={16} />
                      Annulla
                    </button>

                  </div>
              </div>
            </div>
          )}

          {loading && <p className="me-loading">🔄 Caricamento menu...</p>}

          {!loading && mostraPiatti && (
            <div className="me-dish-grid">
              <div className="me-dish-list">
                {piattiVisibili.map((piatto) => (
                  <React.Fragment key={piatto.id}>
                    <article
                      className={`me-dish-card 
  ${editingDishId === piatto.id ? "me-dish-card-active" : ""} 
  ${piatto.visibile === false ? "me-dish-hidden" : ""}`}
                      onClick={() => {
                        if (editingDishId === piatto.id) {
                          setEditingDishId(null);
                          setFileImmagine(null);
                          setAnteprima("");
                          setImmagineUrlAIEdit("");
                        } else {
                          setEditingDishId(piatto.id);
                          setForm({
                            nome: piatto.nome || "",
                            prezzo: piatto.prezzo || "",
                            categoria: piatto.categoria || "",
                            descrizione: piatto.descrizione || "",
                            allergeni: piatto.allergeni || [],
                            ingredienti: Array.isArray(piatto.ingredienti)
                              ? piatto.ingredienti.join(", ")
                              : ""
                          });
                          setFileImmagine(null);
                          setAnteprima(piatto.immagineUrl || "");
                          setImmagineUrlAIEdit("");
                        }
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="me-dish-main">
                        <div className="me-dish-image-wrapper">
                          {piatto.immagineUrl ? (
                            <img
                              src={piatto.immagineUrl}
                              alt={piatto.nome}
                              className="me-dish-image"
                              loading="lazy"
                              onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src =
                                  'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="160" height="120" viewBox="0 0 160 120"><rect width="100%" height="100%" fill="%23f3f4f6"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="%239ca3af" font-family="Arial, Helvetica, sans-serif" font-size="12">Immagine non disponibile</text></svg>';
                              }}
                            />
                          ) : (
                            <div className="me-dish-image-placeholder">🖼️</div>
                          )}
                        </div>

                        <div className="me-dish-content">
                          <div className="me-dish-header">
                            <h4 className="me-dish-name">{piatto.nome}</h4>
                            <span className="me-dish-price">
                              {Number(piatto.prezzo || 0).toFixed(2)} €
                            </span>
                          </div>

                          <div className="me-dish-meta-row">
                            <span className="me-dish-category">
                              {piatto.categoria || "Senza categoria"}
                            </span>
                          </div>

                          {piatto.descrizione && <p className="me-dish-desc">{piatto.descrizione}</p>}
                          
                          {piatto.ingredienti && Array.isArray(piatto.ingredienti) && piatto.ingredienti.length > 0 && (
                            <p className="me-dish-ingredients">
                              <strong>Ingredienti:</strong> {piatto.ingredienti.join(", ")}
                            </p>
                          )}

                          
<div className="me-dish-ios-controls">

  <div className="me-dish-ios-actions">
    <button
      type="button"
      className="me-dish-ios-icon-btn"
      onClick={(e) => {
        e.stopPropagation();
        spostaPiattoSu(piatto);
      }}
      title="Sposta su"
      aria-label={`Sposta ${piatto.nome} verso l'alto`}
    >
      <ChevronUp size={17} />
    </button>

    <button
      type="button"
      className="me-dish-ios-icon-btn"
      onClick={(e) => {
        e.stopPropagation();
        spostaPiattoGiu(piatto);
      }}
      title="Sposta giù"
      aria-label={`Sposta ${piatto.nome} verso il basso`}
    >
      <ChevronDown size={17} />
    </button>

    <button
      type="button"
      className={`me-dish-ios-promo ${
        piatto.inPromozione ? "active" : ""
      }`}
      onClick={(e) => {
        e.stopPropagation();
        togglePromozionePiatto(piatto.id);
      }}
    >
      <Sparkles size={15} />
      <span>
        {piatto.inPromozione ? "In promozione" : "Promozione"}
      </span>
    </button>
  </div>

  <div
    className="me-dish-ios-visibility"
    onClick={(e) => e.stopPropagation()}
  >
    <div className="me-dish-ios-visibility-text">
      <span className="me-dish-ios-visibility-title">
        Visibile
      </span>

      <span className="me-dish-ios-visibility-state">
        {piatto.visibile === false
          ? "Nascosto nel menu"
          : "Mostrato nel menu"}
      </span>
    </div>

    <button
      type="button"
      className={`me-ios-toggle ${
        piatto.visibile !== false ? "on" : ""
      }`}
      onClick={(e) => {
        e.stopPropagation();
        toggleVisibilePiatto(piatto.id);
      }}
      aria-label={
        piatto.visibile === false
          ? `Mostra ${piatto.nome} nel menu`
          : `Nascondi ${piatto.nome} dal menu`
      }
      aria-pressed={piatto.visibile !== false}
    >
      <span className="me-ios-toggle-thumb" />
    </button>
  </div>

</div>
                          
                        
                        </div>
                      </div>
                    </article>
                    {editingDishId === piatto.id && (
                      <div className="inline-edit-panel">
                        <div className="me-card me-edit-card">
                          <div className="me-edit-header">
                            <h4 className="me-section-title" style={{ margin: 0 }}>✏️ Modifica piatto</h4>
                            <button
                              className="me-action-pill icon"
                              onClick={() => {
                                setEditingDishId(null);
                                setFileImmagine(null);
                                setAnteprima("");
                                setImmagineUrlAIEdit("");
                              }}
                            >
                              <X size={16} />
                            </button>
                          </div>
                          <div className="me-grid me-grid-2">
                            <div className="me-field">
                              <label className="me-label">Nome</label>
                              <input
                                className="me-input"
                                value={form.nome}
                                onChange={(e) => setForm({ ...form, nome: e.target.value })}
                              />
                            </div>
                            <div className="me-field">
                              <label className="me-label">Prezzo</label>
                              <input
                                className="me-input"
                                value={form.prezzo}
                                onChange={(e) => setForm({ ...form, prezzo: e.target.value })}
                              />
                            </div>
                          </div>
                          <div className="me-grid me-grid-2">
                            <div className="me-field">
                              <label className="me-label">Categoria</label>
                              <select
                                className="me-input"
                                value={form.categoria}
                                onChange={(e) => setForm({ ...form, categoria: e.target.value })}
                              >
                                <option value="">Seleziona categoria</option>
                                {categorie.map((cat) => (
                                  <option key={cat.id} value={cat.nome}>
                                    {cat.nome}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="me-field">
                              <label className="me-label">Ingredienti</label>
                              <input
                                className="me-input"
                                value={form.ingredienti}
                                onChange={(e) => setForm({ ...form, ingredienti: e.target.value })}
                                placeholder="es. pomodoro, mozzarella, basilico"
                              />
                            </div>
                          </div>
                          <div className="me-field">
                            <label className="me-label">Descrizione</label>
                            <textarea
                              className="me-input me-textarea"
                              value={form.descrizione}
                              onChange={(e) => setForm({ ...form, descrizione: e.target.value })}
                            />
                          </div>
                          <div className="me-grid me-grid-2 me-align-center" style={{ marginTop: 12 }}>
                            <div className="me-field">
                              <label className="me-label">Immagine</label>
                              <div className="me-ai-image-row">
                                <input
                                  type="file"
                                  accept="image/*"
                                  className="me-input"
                                  onChange={(e) => {
                                    const file = e.target.files?.[0] || null;
                                    setFileImmagine(file);
                                    setImmagineUrlAIEdit("");
                                    if (file) {
                                      const reader = new FileReader();
                                      reader.onloadend = () => {
                                        setAnteprima(reader.result);
                                      };
                                      reader.readAsDataURL(file);
                                    } else {
                                      setAnteprima(piatto.immagineUrl || "");
                                    }
                                  }}
                                />
                                <button
                                  type="button"
                                  className="me-action-pill promo active"
                                  disabled={!aiEnabled || !aiCredits || aiImageUploading}
                                  onClick={apriAIPerModifica}
                                >
                                  <Sparkles size={16} />
                                  Genera con AI
                                </button>
                              </div>
                              {aiEnabled && aiCredits !== null && (
                                <p className="me-ai-credits-hint">
                                  Crediti AI Immagini: <strong>{aiCredits}</strong><br />
                                  Crediti AI Traduzioni: <strong>{translationCredits}</strong>
                                </p>
                              )}
                              {!aiEnabled && (
                                <p className="me-ai-credits-hint me-ai-credits-disabled">
                                  La generazione con AI è disabilitata.
                                </p>
                              )}
                            </div>
                            <div className="me-field me-field-preview">
                              {anteprima ? (
                                <img
                                  src={anteprima}
                                  alt="Anteprima piatto"
                                  className="me-add-image-preview"
                                />
                              ) : (
                                <div className="me-add-image-placeholder">Nessuna immagine</div>
                              )}
                            </div>
                          </div>
                          <div className="me-edit-actions-footer me-edit-actions-3">

                            <button
                              className="me-action-pill primary big"
                              onClick={salvaModifiche}
                              disabled={isSavingEdit || aiImageUploading}
                            >
                              <Save size={16} />
                              Salva
                            </button>

                            <button
                              className="me-action-pill danger big"
                              onClick={() => eliminaPiatto(piatto.id)}
                            >
                              <Trash2 size={16} />
                              Cancella
                            </button>

                            <button
                              className="me-action-pill big"
                              onClick={closeInlineEdit}
                            >
                              <X size={16} />
                              Annulla
                            </button>

                          </div>

                          {/* 🔴 BLOCCO ELIMINAZIONE (stile iOS) */}
                        </div>
                      </div>
                    )}
                </React.Fragment>
              ))}
            </div>
            </div>
          )}
        </section>

{/* Categories management */}
<section className="me-section">

  {mostraGestioneCategorie && (
            <>
              <div className="me-card me-add-category-card">
                <div className="me-grid me-grid-2 me-align-end">
                  <div className="me-field">
                    <label className="me-label">Nuova categoria</label>
                    <input
                      type="text"
                      className="me-input"
                      placeholder="Es. Secondi di pesce"
                      value={nuovaCategoria}
                      onChange={(e) => setNuovaCategoria(e.target.value)}
                    />
                  </div>
                  <div className="me-field me-field-right">
                    <button className="me-action-pill primary" onClick={aggiungiCategoria}>
                      <Save size={16} />
                      Aggiungi categoria
                    </button>
                  </div>
                </div>
              </div>

              <div className="me-category-list">
                {categorie.map((cat) => (
                  <div 
                    key={cat.id} 
                    className={`me-card me-category-card ${cat.visibile === false ? "me-category-hidden" : ""}`}
                  >
                    <div className="me-category-main">
                      <span className="me-category-name">🍽 {cat.nome}</span>
                      <div className="me-category-badges">
                        {cat.visibile === false && <span className="me-badge me-badge-muted">Nascosta</span>}
                      </div>
                    </div>

                    <div className="me-category-actions">
                      <button className="me-action-pill icon" title="Sposta su" onClick={() => spostaSu(cat)}>
                        <ChevronUp size={16} />
                      </button>
                      <button className="me-action-pill icon" title="Sposta giù" onClick={() => spostaGiu(cat)}>
                        <ChevronDown size={16} />
                      </button>


                      <button
                        className={`me-action-pill ${cat.visibile !== false ? "active" : ""}`}
                        onClick={() => toggleVisibilitaCat(cat.id)}
                      >
                        {cat.visibile !== false ? <Eye size={16}/> : <EyeOff size={16}/>}
                      </button>

                      <button
                        className="me-action-pill"
                        onClick={() => apriModificaCat(cat)}
                      >
                        ✏️ Modifica
                      </button>
                      <button
                        className="me-action-pill"
                        style={{ color: "#ff6b6b" }}
                        onClick={() => eliminaCategoria(cat.id)}
                      >
                        Elimina
                      </button>
                    </div>

                    {mostraModificaCat && catSelezionata?.id === cat.id && (
                      <div className="me-category-edit-row">
                        <input
                          type="text"
                          className="me-input"
                          value={nuovoNomeCat}
                          onChange={(e) => setNuovoNomeCat(e.target.value)}
                        />
                        <button className="me-action-pill primary" onClick={salvaModificaCat}>
                          <Save size={16} />
                          Salva
                        </button>
                        <button
                          className="me-action-pill"
                          onClick={() => {
                            setMostraModificaCat(false);
                            setCatSelezionata(null);
                          }}
                        >
                          <X size={16} />
                          Annulla
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </>
          )}
        </section>

        {/* Quick add category form (optional) */}
        {mostraFormCategoria && (
          <section className="me-section">
            <div className="me-card me-add-category-inline">
              <h4 className="me-section-title-small">➕ Nuova categoria veloce</h4>
              <div className="me-grid me-grid-2 me-align-end">
                <div className="me-field">
                  <label className="me-label">Nome categoria</label>
                  <input
                    type="text"
                    className="me-input"
                    value={nuovaCategoria}
                    onChange={(e) => setNuovaCategoria(e.target.value)}
                  />
                </div>
                <div className="me-field me-field-right">
                  <button
                    className="me-btn me-btn-primary me-btn-xs"
                    onClick={() => {
                      aggiungiCategoria();
                      setMostraFormCategoria(false);
                    }}
                  >
                    ✅ Salva
                  </button>
                  <button className="me-btn me-btn-ghost me-btn-xs" onClick={() => setMostraFormCategoria(false)}>
                    ❌ Annulla
                  </button>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* ── Impostazioni locali (coperto) — in fondo ── */}
        <section className="me-section me-section-settings">
          <div className="me-settings-bar">
            <div className="me-settings-bar-left">
              <span className="me-settings-label">💶 Coperto</span>
              <span className="me-settings-value">
                {(parseFloat(String(prezzoCoperto).replace(",", ".")) || 0).toFixed(2)} €
              </span>
            </div>
            <div className="me-settings-bar-controls">
              <button
                className="me-coperto-btn"
                onClick={async () => {
                  const nuovo = Math.max(0, (parseFloat(String(prezzoCoperto).replace(",", ".")) || 0) - 0.5).toFixed(2);
                  setPrezzoCoperto(nuovo);
                  try {
                    await setDoc(doc(db, "coperti", localeTag), { prezzo: nuovo });
                    await updateDoc(doc(db, "locali", localeTag), {
                      prezzoCoperto: parseFloat(nuovo)
                    });
                    setErrore("success_coperto");
                    setTimeout(() => setErrore(""), 1500);
                  } catch (e) {
                    setErrore("❌ Errore salvataggio");
                  }
                }}
                disabled={loadingCoperto}
              >
                −
              </button>
              <button
                className="me-coperto-btn"
                onClick={async () => {
                  const nuovo = ((parseFloat(String(prezzoCoperto).replace(",", ".")) || 0) + 0.5).toFixed(2);
                  setPrezzoCoperto(nuovo);
                  try {
                    await setDoc(doc(db, "coperti", localeTag), { prezzo: nuovo });
                    await updateDoc(doc(db, "locali", localeTag), {
                      prezzoCoperto: parseFloat(nuovo)
                    });
                    setErrore("success_coperto");
                    setTimeout(() => setErrore(""), 1500);
                  } catch (e) {
                    setErrore("❌ Errore salvataggio");
                  }
                }}
                disabled={loadingCoperto}
              >
                +
              </button>
            </div>
          </div>
        </section>

        {/* AI Image Popup */}
        <AIImagePopup
          visible={showAIPopup}
          onClose={() => setShowAIPopup(false)}
          dishName={aiPopupDishName}
          aiCredits={aiCredits || 0}
          localeTag={localeTag}
          onComplete={handleAIComplete}
        />

        <TranslateWithAIModal
          open={showTranslateAIModal}
          onClose={() => {
            setShowTranslateAIModal(false);
            setSingleTranslateDish(null);
          }}
          localeTag={localeTag}
          dishes={menu}
          categories={categorie}
          translationCredits={translationCredits}
          mode={singleTranslateDish ? "single" : "bulk"}
          dish={singleTranslateDish}
          onCompleted={async () => {
            await aggiornaMenu();
            await fetchTranslationCredits();
          }}
        />


        {/* Overlay per aggiunta allergene */}
        {showAddAllergeneFor && (
          <div 
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10001
            }}
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                setShowAddAllergeneFor(null);
                setNuovoAllergene("");
                setAddAllergeneForIndex(null);
              }
            }}
          >
            <div 
              style={{
                background: "#16181d",
border: "1px solid rgba(255,255,255,0.08)",
color: "#fff",
                padding: "24px",
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                maxWidth: "400px",
                width: "90%"
              }}
            >
              <h3 style={{ marginTop: 0, marginBottom: "16px", color: "#fff" }}>Aggiungi Allergene</h3>
              <input
                type="text"
                className="edit-dish-input"
                placeholder="Nuovo allergene"
                value={nuovoAllergene}
                onChange={(e) => setNuovoAllergene(e.target.value)}
                autoFocus
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    const nome = await handleSaveAllergene();
                    if (nome) {
                      if (showAddAllergeneFor === "edit") {
                        setForceSelectAllergene(nome);
                      } else if (showAddAllergeneFor === "add" && addAllergeneForIndex !== null) {
                        setPiattiDaAggiungere((prev) => {
                          const copy = [...prev];
                          copy[addAllergeneForIndex] = {
                            ...copy[addAllergeneForIndex],
                            allergeni: [...copy[addAllergeneForIndex].allergeni, nome],
                          };
                          return copy;
                        });
                      }
                    }
                  } else if (e.key === "Escape") {
                    setShowAddAllergeneFor(null);
                    setNuovoAllergene("");
                    setAddAllergeneForIndex(null);
                  }
                }}
                style={{ width: "100%", marginBottom: "12px" }}
              />
              <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                <button
                  type="button"
                  className="edit-dish-btn edit-dish-btn-cancel"
                  onClick={() => {
                    setShowAddAllergeneFor(null);
                    setNuovoAllergene("");
                    setAddAllergeneForIndex(null);
                  }}
                >
                  Annulla
                </button>
                <button
                  type="button"
                  className="edit-dish-btn edit-dish-btn-save"
                  onClick={async () => {
                    const nome = await handleSaveAllergene();
                    if (nome) {
                      if (showAddAllergeneFor === "edit") {
                        setForceSelectAllergene(nome);
                      } else if (showAddAllergeneFor === "add" && addAllergeneForIndex !== null) {
                        setPiattiDaAggiungere((prev) => {
                          const copy = [...prev];
                          copy[addAllergeneForIndex] = {
                            ...copy[addAllergeneForIndex],
                            allergeni: [...copy[addAllergeneForIndex].allergeni, nome],
                          };
                          return copy;
                        });
                      }
                    }
                  }}
                >
                  Salva
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    {deleteConfirm && (
      <div className="me-modal-overlay">
        <div className="me-modal">
          <h3>⚠️ Elimina piatto</h3>

          <p>
            Vuoi eliminare <strong>{deleteConfirm.nome}</strong>?
          </p>

          <span className="me-modal-warning">
            Questa operazione non può essere annullata
          </span>

          <div className="me-modal-actions">
            <button
              className="me-action-pill"
              onClick={() => setDeleteConfirm(null)}
            >
              <X size={16} />
              Annulla
            </button>

            <button
              className="me-action-pill danger"
              onClick={confermaEliminazione}
            >
              <Trash2 size={16} />
              Elimina
            </button>
          </div>
        </div>
      </div>
    )}
    {aiImageUploading && (
      <div className="ai-upload-overlay">
        <div className="ai-upload-popup">
          <div className="ai-upload-spinner"></div>


          <h3>Preparazione immagine AI</h3>
          <p className="ai-upload-small">
            Non chiudere la pagina
          </p>

          <p>
            Attendi qualche secondo...
            <br />
            stiamo ottimizzando e caricando l’immagine.
          </p>
        </div>
      </div>
    )}
    {popupLimitePiatti && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.55)",
      backdropFilter: "blur(12px)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999
    }}
  >
    <div
      style={{
        width: "92%",
        maxWidth: "430px",
        background: "#1c1c1f",
        borderRadius: "24px",
        padding: "2rem",
        textAlign: "center",
        boxShadow: "0 20px 60px rgba(0,0,0,.45)"
      }}
    >
      <div
        style={{
          fontSize: "3.5rem",
          marginBottom: "1rem"
        }}
      >
        ⚠️
      </div>

      <h2
        style={{
          margin: 0,
          color: "#fff"
        }}
      >
        Limite raggiunto
      </h2>

      <p
        style={{
          color: "#bdbdbd",
          lineHeight: 1.6,
          marginTop: "1rem",
          marginBottom: "1.8rem"
        }}
      >
        Hai raggiunto il numero massimo di piatti consentito per il tuo locale.
        <br /><br />
        Se desideri aggiungerne altri, contatta QrMenu Italia per aumentare il limite del tuo piano.
      </p>

      <button
        onClick={() => setPopupLimitePiatti(false)}
        style={{
          width: "100%",
          padding: "14px",
          border: "none",
          borderRadius: "14px",
          background: "#2ecc71",
          color: "#fff",
          fontSize: "1rem",
          fontWeight: "700",
          cursor: "pointer"
        }}
      >
        ✓ Ho capito
      </button>
    </div>
  </div>
)}
    </>
  );
}

